import { Link } from 'react-router-dom'
import PhotoSlider from './PhotoSlider'

/**
 * A trailer rendered the way its spec plate is: photo, then name and rate
 * stamped at the top, then the numbers a contractor actually checks in a
 * fixed grid below.
 */
export default function DataPlate({ trailer }) {
  return (
    <article className="plate">
      <div className="plate__photo">
        <PhotoSlider
          images={trailer.images ?? [trailer.image]}
          alt={`${trailer.unit} \u2014 ${trailer.name}`}
        />
      </div>

      <div className="plate__head">
        <div>
          <h3 className="plate__name">{trailer.name}</h3>
          <div className="plate__unit">
            {trailer.unit} &middot; {trailer.model}
          </div>
        </div>
        <div className="plate__rate">
          <strong>${trailer.dayRate}</strong>
          <span>per day</span>
        </div>
      </div>

      <dl className="plate__specs">
        {trailer.specs.map((spec) => (
          <div className="plate__spec" key={spec.label}>
            <dt>{spec.label}</dt>
            <dd>{spec.value}</dd>
          </div>
        ))}
      </dl>

      <div className="plate__body">
        <p className="plate__use">{trailer.use}</p>

        <ul className="plate__tags">
          {trailer.tags.map((tag) => (
            <li key={tag}>{tag}</li>
          ))}
        </ul>

        <div className="plate__cta">
          <Link
            className="btn btn--primary btn--wide"
            to={`/reserve/${trailer.id}`}
          >
            Reserve {trailer.unit}
          </Link>
        </div>
      </div>
    </article>
  )
}
